import FormAngket from "../components/FormAngket/Home";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <FormAngket/>
    </div>
  );
}
